<script setup>
import AppIcon from 'module/icon/AppIcon.vue';
import { trackGa4 } from 'util/googleAnalytics';
import { track as trackServerSide } from 'util/statistics';
import { log } from '@karriereat/action-logger';
import { postJson } from 'util/xhr';
import { API_ENDPOINT_LOG_APPLICATION_CLICK } from 'app/endpoints';
import { user } from 'app/user';

const props = defineProps({
    isSmartApplyJob: Boolean,
    applyUrl: String,
    jobId: [String, Number],
    jobBundleId: Number,
    isDisabled: Boolean,
    text: String,
    isSeamless: Boolean,
    jobBundleLabel: String,
});

function executeTracking() {
    const applicationType = props.isSmartApplyJob ? 'SmartBewerben' : 'External';

    trackGa4({
        event: 'job_apply_click',
        application_type: applicationType,
        job_id: props.jobId ?? null,
        job_type: props.isSeamless ? 'SJA' : 'Standard',
        product_type: props.jobBundleLabel ?? null,
        method: 'Ad Header',
        user_data: {
            email: user.getUserMail(),
        },
    });

    const data = {
        jobId: props.jobId,
        jobBundleId: props.jobBundleId,
        type: props.isSmartApplyJob ? 'smartbewerben' : 'extern',
    };

    trackServerSide({
        name: 'job_apply_click',
        params: {
            application_type: applicationType,
        },
    });
    log('apply-click', data);

    postJson(
        `${API_ENDPOINT_LOG_APPLICATION_CLICK}`,
        { data },
    );
}

function redirectToApplyForm() {
    window.open(props.applyUrl, '_blank', 'noopener');
}

function onButtonClick() {
    executeTracking();
    redirectToApplyForm();
}
</script>

<template>
    <div
        class="m-applyButton"
        data-is-link="true"
        :data-is-smart-apply-job="isSmartApplyJob"
        :data-apply-url="applyUrl"
        :data-job-id="jobId"
    >
        <a
            :href="applyUrl"
            data-qa="apply button"
            target="_blank"
            rel="noopener nofollow"
            :class="{
                'm-applyButton__button': true,
                'm-applyButton__button--smartApply': isSmartApplyJob,
                'm-applyButton__button--smartApplyDisabled': isSmartApplyJob && isDisabled,
                'm-applyButton__button--external': !isSmartApplyJob,
                'm-applyButton__button--disabled': isDisabled,
                'm-applyButton__button--noPointerEvents': isDisabled,
            }"
            :aria-disabled="isDisabled ? 'true' : 'false'"
            @click.prevent="onButtonClick"
        >
            <template v-if="isSmartApplyJob">
                <img
                    src="/assets/images/smartApply-logo-condensed.svg"
                    alt="Smart über karriere.at bewerben"
                >
            </template>
            <template v-else>
                <AppIcon
                    name="external-link"
                    size="small"
                />
                <span class="m-applyButton__label">{{ text }}</span>
            </template>
        </a>
    </div>
</template>

<style lang="scss">
@use "styles";
</style>
